import { axiosInstance, type CustomResponseFormat } from "api/instance";
import { UserType } from "recoil/userAtom";
import { UserSimpleType } from "../recoil/userSimpleAtom";
import { axiosInstancePromotion } from "./instancePromotion";

export const USER_DOMAIN = "user";

export const USER_DETAIL_ENDPOINT = "detail";
export const USER_V2_SIMPLE_ENDPOINT = "v2/simple";
export const USER_NICKNAME_SUBMIT_ENDPOINT = "nickname/submit";
export const USER_V2_NICKNAME_SUBMIT_ENDPOINT = "v2/nickname/submit";
export const USER_GENDER_SUBMIT_ENDPOINT = "gender/submit";
export const USER_AGE_SUBMIT_ENDPOINT = "age/submit";
export const USER_JOB_SUBMIT_ENDPOINT = "job/submit";
export const USER_COACH_REASSIGN_ENDPOINT = "coach/reassign";
export const USER_LOGIN = "login";

export interface UserLogin {
  type: string;
  idToken: string;
}

export const userApi = {
  getSimplePromotion: () =>
    axiosInstancePromotion.get<CustomResponseFormat<UserSimpleType>>(
      `${USER_DOMAIN}/${USER_V2_SIMPLE_ENDPOINT}`
    ),

  getDetail: () =>
    axiosInstance.get<CustomResponseFormat<UserType>>(
      `${USER_DOMAIN}/${USER_DETAIL_ENDPOINT}`
    ),

  submitNickname: (nickname: string) =>
    axiosInstance.post<void>(
      `${USER_DOMAIN}/${USER_NICKNAME_SUBMIT_ENDPOINT}`,
      { nickname: nickname }
    ),
  submitNicknamePromotion: (nickname: string) =>
    axiosInstancePromotion.post<void>(
      `${USER_DOMAIN}/${USER_V2_NICKNAME_SUBMIT_ENDPOINT}`,
      { nickname: nickname }
    ),
  reassignCoach: () =>
    axiosInstance.get<CustomResponseFormat>(
      `${USER_DOMAIN}/${USER_COACH_REASSIGN_ENDPOINT}`
    ),

  login: (param: UserLogin) =>
    axiosInstance.post<CustomResponseFormat>(`${USER_DOMAIN}/${USER_LOGIN}`, {
      type: param.type,
      idToken: param.idToken,
    }),

  submitAge: (age: number) =>
    axiosInstance.post<void>(`${USER_DOMAIN}/${USER_AGE_SUBMIT_ENDPOINT}`, {
      age: age,
    }),

  submitJob: (job: string) =>
    axiosInstance.post<void>(`${USER_DOMAIN}/${USER_JOB_SUBMIT_ENDPOINT}`, {
      job: job,
    }),

  submitGender: (gender: string) =>
    axiosInstance.post<void>(`${USER_DOMAIN}/${USER_GENDER_SUBMIT_ENDPOINT}`, {
      gender: gender,
    }),
};
